const iOSOriginRegexp = /^https:\/\/app(?:\.dev)?\.skade\.io$/;

export default ({ store }) => {
  function handleFirebaseToken(token) {
    store.dispatch('api/saveDeviceToken', token);
  }

  function handleEnableNotifications(enableNotifications) {
    store.dispatch(
      'api/resetPushNotificationsFromOSPrompt',
      enableNotifications
    );
  }

  function handleAndroidPostMessage(event) {
    const port = event.ports[0];
    if (typeof port === 'undefined') return;

    port.onmessage = function (event) {
      const parsedData = JSON.parse(event.data);
      if (parsedData?.token) handleFirebaseToken(parsedData.token);
      else if (parsedData?.enableNotifications) {
        handleEnableNotifications(parsedData.enableNotifications);
      } else if (parsedData?.ping && store.state.authentication?.me?.userId) {
        port.postMessage(JSON.stringify({ message: 'pong' }));
      }
    };
  }

  function handleiOSPostMessage(event) {
    const logContext = 'iOSPostMessageHandler';

    try {
      if (!event.origin) {
        console.debug('Received postMessage without origin', {
          logContext,
          event,
        });
        return;
      }

      // iOS postMessages may only be received if coming from authorized origins.
      // NOTE: this might need to be restricted further, to prevent attacks from other JS scripts
      if (!iOSOriginRegexp.test(event.origin)) {
        console.debug('Received postMessage with unauthorized origin', {
          logContext,
          event,
        });
        return;
      }

      console.debug('Received postMessage with authorized origin', {
        logContext,
        event,
      });

      // Support both object payloads and JSON payloads
      let postMessageData = event.data;
      if (typeof postMessageData === 'string') {
        try {
          postMessageData = JSON.parse(postMessageData);
        } catch (_) {
          throw new Error('Failed to parse postMessage data as JSON string');
        }
      }

      if (
        postMessageData?.token &&
        typeof postMessageData?.token === 'string'
      ) {
        console.debug('Processing postMessage as user Firebase token', {
          logContext,
          event,
        });
        handleFirebaseToken(postMessageData.token);
      } else if (
        postMessageData?.enableNotifications === true &&
        typeof postMessageData?.enableNotifications === 'boolean'
      ) {
        console.debug('Processing postMessage as enableNotifications', {
          logContext,
          event,
        });
        handleEnableNotifications(true);
      } else {
        console.debug('Unhandled iOS postMessage', {
          logContext,
          event,
        });
      }
    } catch (error) {
      console.error('Error handling iOS postMessage', {
        logContext,
        event,
        error,
      });
    }
  }

  window.addEventListener('message', function (event) {
    handleAndroidPostMessage(event);
  });

  // This object is injected by the iOS app
  if (window.skade?.sdk) {
    console.debug('iOS Skade SDK detected, setting up postMessage listener');

    window.addEventListener('message', function (event) {
      handleiOSPostMessage(event);
    });
  }
};
